import { createComponent } from '@mtfe/sweet';
import { oadLX } from '@mtfe/pr-oad';
import Dialog, { hideDialog } from '../common/Dialog/script';

import style from './style.less';
import tpl from './dom.html';
import innerTpl from './innerTpl.html';

const TrafficQRCodeModal = () => {
    try {
        const events = {};
        const innerData = {
            btnText: '长按二维码保存图片',
        };

        const modalContent = createComponent(innerTpl, { data: innerData, style }, events);
        const data = {
            renderConfirmDialog: Dialog({
                contentComponent: modalContent,
                onClose: () => {
                    oadLX.mc('b_waimai_4no5be07_mc');
                },
            }),
        };
        createComponent(tpl, { data });
    } catch (error) {
        return '';
    }
};

TrafficQRCodeModal.hideTrafficInitModal = () => {
    hideDialog();
};
export default TrafficQRCodeModal;
